export const formatLicensePlateInput = (input: string): string => {
  // If the input is empty or just spaces, return empty string
  if (!input.trim()) return "";

  // Remove any existing spaces and convert to uppercase
  const cleanInput = input.replace(/\s/g, "").toUpperCase();

  // If the input is too short, return as is
  if (cleanInput.length < 2) return cleanInput;

  // Format as user types
  const match = cleanInput.match(/^([A-z]*)(\d*)([A-z]*)$/);
  if (match) {
    const [, letters1, numbers, letters2] = match;
    return `${letters1} ${numbers} ${letters2}`.trim();
  }
  return cleanInput;
};
